import { CollapsibleContainer, DateInput, SolidCircleCheckIcon, TextInput } from 'slab'

import { useOnboarding } from '../OnboardingContext'

export function SelfParticipantCard () {
  const { onboardingData } = useOnboarding()

  return (
    <CollapsibleContainer
      defaultOpen={false}
      heading='You'
      headingIconContent={
        <div className='text-green-400'>
          <SolidCircleCheckIcon aria-label='(complete)' size={16} />
        </div>
      }
    >
      <div className='p-4 space-y-4'>
        <div className='flex flex-col xs:flex-row gap-4'>
          <TextInput
            label='First name'
            defaultValue={onboardingData?.member?.given_name}
            disabled
          />
          <TextInput
            label='Last name'
            defaultValue={onboardingData?.member?.family_name}
            disabled
          />
          <DateInput
            label='Date of birth'
            defaultValue={onboardingData?.member?.date_of_birth || undefined}
            disabled
          />
        </div>
      </div>
    </CollapsibleContainer>
  )
}
